import { Ng2StateDeclaration } from '@uirouter/angular';
import { TrainScheduleDashboardComponent } from './containers/train-schedule-dashboard/train-schedule-dashboard.component';

export const trainSchedulesState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'pools' is a child of 'app'
    name: 'train-schedule-dashboard',
    url: '/project/:projectId/configuration/train-schedule',
    component: TrainScheduleDashboardComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const TRAIN_SCHEDULE_STATES = [
    trainSchedulesState
];
